import * as React from 'react';
import { Intent, Button, Tooltip, H4, Spinner, Alert, H3, Card, Elevation, Classes, Drawer, Position } from '@blueprintjs/core';
import { LoadableSVG } from '../LoadableSVG';
import { CoachingAudio } from '../CoachingAudio';
import { executeQueryPostAuth, executeQueryGetAuth } from 'app/utils/api';
import { UserState } from 'app/reducers/state';
import { KryPlayDetails } from '../KryPlayDetails';
import { translateKey } from 'app/utils/forms';
import { getDynamicJournalConfiguration } from 'app/utils/scores';
import { clone } from 'lodash';
import * as superagent from 'superagent';
import TextAreaV2 from '../TextAreaV2';

const buttonTopOffset = "-15px";

interface Props {
    jouranlGraphic: string;
    journalGraphicSub1: string;
    journalGraphicSub2: string;
    journalGrphicPost: string;
    coachingAudio: string;
    menuConfig: any;
    gameID: string;
    user: UserState;
    prompt: string;
    blockObjectives?: boolean;
    forLP: boolean;
    cachedSimulatedData: any;
    recieveJournal: (entry: string) => void;
    goBackHome: () => void;
};

interface State {
    isJournalVisible: boolean;
    hasAudioFinishedOnce: boolean;
    writtenJouranl: string;
    loadingObjectiveData: boolean;
    objectiveData: any;
    hasViewedObjectives: boolean;
    viewGraphic: boolean;
    viewSub1: boolean;
    viewSub2: boolean;
    viewSub3: boolean;
    hasViewedAllObjectives: boolean;
    showPlayButton: boolean;
    promptToGoHome: boolean;
    promptData: any;
    promptInput: any;
}

export class ClassicJournalWriter extends React.Component<Props, State> {

    state: State = {
        isJournalVisible: false,
        hasAudioFinishedOnce: false,
        writtenJouranl: '',
        loadingObjectiveData: true,
        hasViewedObjectives: true,
        hasViewedAllObjectives: false,
        viewSub1: false,
        viewSub2: false,
        viewSub3: false,
        viewGraphic: true,
        objectiveData: {},
        showPlayButton: false,
        promptToGoHome: false,
        promptData: {},
        promptInput: {}
    }

    componentDidMount() {
        superagent.
        get('assets/prompts.json')
        .end((error: any, response: any) => {
            const promptData = JSON.parse(response.text);

            let newPromptInput = {};

            if (this.props.user.classicMode === 2) {
                if (promptData && promptData.classic) {
                    for (let i = 0; i < promptData.classic.post.length; i++) {
                        const __prompt = promptData.classic.pre[i];
                        newPromptInput[__prompt] = '';
                    }
                }
            }
            else {
                if (promptData && promptData.lab) {
                    for (let i = 0; i < promptData.lab.post.length; i++) {
                        const __prompt = promptData.lab.pre[i];
                        newPromptInput[__prompt] = '';
                    }
                }
            }
            this.setState({
                promptData,
                promptInput: newPromptInput
            });
        });

        executeQueryPostAuth("data/results/" + this.props.gameID, {}, this.props.user, (postResponse) => {
            executeQueryGetAuth("data/results/" + this.props.gameID, {}, this.props.user, (objectiveResponse) => {
                const response = JSON.parse(objectiveResponse.text);

                const {
                    blockObjectives
                } = this.props;

                // Mark objectives viewed if we're blocking them
                const hasViewedAllObjectives = blockObjectives === true;

                this.setState({
                    loadingObjectiveData: false,
                    objectiveData: response,
                    hasViewedAllObjectives
                });
            });
        });
    }

    getConfigInfo = (config: string, scenario: string, name: string) => {
        let response: any = undefined;

        const lines = config.split('\n');

        for (let i = 0; i < lines.length; i++) {
            const bits = lines[i].split('\t');

            try {
                if (bits[0] === scenario) {
                    if (bits[4] === name) {
                        const difficulty = parseInt(bits[5]);
                        const score = parseInt(bits[5]);
                        const successA = bits[8];
                        const failA = bits[9];

                        response = { difficulty, score, successA, failA };
                    }
                }
            }
            catch (e) { }
        }

        return response;
    }

    getPositionedAdjectives = (_data: any[], max: number, direction: number, nameMatch: string) => {
        let data: any[] = [];

        if (nameMatch === undefined) {
            data = _data;
        }
        else {
            for (let i = 0; i < _data.length; i++) {
                const name: string = _data[i].name;

                if (name !== undefined) {
                    if (name.toLowerCase().includes(nameMatch.toLowerCase())) {
                        data.push(_data[i]);
                    }
                }
            }
        }

        if (data.length <= max) {
            let buffer2 = '';

            for (let i = 0; i < data.length; i++) {
                // Check for an and to make gramatical sense
                if (buffer2 !== '') {
                    buffer2 += ' and ';
                }

                buffer2 += data[i].adjective;
            }

            return buffer2;
        }

        let buffer = '';

        for (let i = 0; i < max; i++) {
            // Do we count from the start of the array, or the back?
            const index = direction === 1 ? i : data.length - 1 - i;

            // Check for an and to make gramatical sense
            if (buffer !== '') {
                buffer += ' and ';
            }

            buffer += data[index].adjective;
        }

        return buffer;
    }

    getTopAdjectives = (data: any, max: number, nameMatch: any) => {
        return this.getPositionedAdjectives(data, max, 1, nameMatch);
    }

    // Hardest because the highest difficulty objectives are at the bottom
    getBottomAdjectives = (data: any, max: number, nameMatch: any) => {
        return this.getPositionedAdjectives(data, max, -1, nameMatch);
    }

    getSectionFromSheet2 = (configStatement: string, x: number, y: number) => {
        const lines: any[] = configStatement.split('\n');

        if (lines.length <= y) {
            return '';
        }

        const targetLine = lines[y];
        const bits = targetLine.split('\t');

        if (bits.length <= x) {
            return '';
        }

        return bits[x];
    }

    convertScenarioToX = (scenarioName: string) => {
        const scenario = scenarioName.toLowerCase();

        if (scenario === 'scenario_1_a1') return 1;
        if (scenario === 'scenario_1_a2') return 2;
        if (scenario === 'scenario_1_a3') return 3;

        // Fallback to directive if we can't figure it out
        return 1;
    }

    convertScenarioToStyle = (scenarioName: string) => {
        const scenario = scenarioName.toLowerCase();

        if (scenario === 'scenario_1_a1') return 'Directive';
        if (scenario === 'scenario_1_a2') return 'Delegative';
        if (scenario === 'scenario_1_a3') return 'Participative';

        // Fallback to directive if we can't figure it out
        return 'Directive';
    }

    renderSimulatedSection = (data: any, scenario: string) => {
        const final = data.final;
        const successObjectives = data.successObjectives;
        const failedObjectives = data.failedObjectives;

        const topAchieved = this.getBottomAdjectives(successObjectives, 3, undefined);
        const notAchieved = this.getTopAdjectives(failedObjectives, 3, undefined);

        const message = <div>
            <Card interactive={false} elevation={Elevation.ZERO}>
                <h5>What Went Well</h5>
                <ul>
                    {topAchieved}
                </ul>
            </Card>

            <Card interactive={false} elevation={Elevation.ZERO}>
                <h5>What To Try Next Time</h5>
                <ul>
                    {notAchieved}
                </ul>
            </Card>
        </div>

        return {
            score: final,
            message_success: message,
            message_fail: message,
            style: this.convertScenarioToStyle(scenario)
        }
    }

    renderSimulatedSectionConfig = (config: any) => {
        const pass = parseFloat(config.score) >= 65.0;

        const message = pass ? config.message_success : config.message_fail;

        return <div>
            {message}
        </div>
    }

    renderConstructiveFeedback = () => {
        const {
            cachedSimulatedData
        } = this.props;

        let innards = <Spinner />

        const scenario = this.props.menuConfig.slug.replace("classic_", "");
        const section = this.renderSimulatedSection(cachedSimulatedData.coaching[scenario], scenario);

        innards = <span>
            {this.renderSimulatedSectionConfig(section)}
        </span>

        return <span style={{ flexGrow: 1, flexBasis: 0 }}>
            <span style={{ flexShrink: 1, transition: 'all 2s' }}>
                <span style={{ position: 'relative' }}>
                    {innards}
                </span>
            </span>
        </span>
    }

    renderGraphic = () => {
        const {
            blockObjectives
        } = this.props;

        const hideObjectiveView = blockObjectives === true;

        const {
            viewGraphic,
            viewSub1,
            viewSub2,
            viewSub3,
            objectiveData
        } = this.state;

        if (viewGraphic) {
            return <span style={{ flexGrow: 1, flexBasis: 0 }}>
                <LoadableSVG imgURL={this.props.jouranlGraphic} />
            </span>
        }

        if (viewSub1) {
            return <span style={{ flexGrow: 1, flexBasis: 0 }}>
                <LoadableSVG imgURL={this.props.journalGraphicSub1} />
            </span>
        }

        if (viewSub2) {
            return <span style={{ flexGrow: 1, flexBasis: 0 }}>
                <LoadableSVG imgURL={this.props.journalGraphicSub2} />
            </span>
        }

        if (viewSub3) {
            return this.renderConstructiveFeedback();
        }

        if (hideObjectiveView) {
            return <span style={{ flexGrow: 1, flexBasis: 0 }}>
                <p style={{ textAlign: 'center' }}>
                    <H3>{translateKey('vleader.noObjectives')}</H3>
                </p>
            </span>
        }

        // Render the objectives
        return <span style={{ flexGrow: 1, flexBasis: 0 }}>
            <KryPlayDetails
                hideScore={true}
                customWarningStyle={{ right: '25px', top: '15px' }}
                user={this.props.user}
                selectedGame={objectiveData}
                canEditJournal={false}
                inSimulator={true}
                hasSeenAllCategories={() => {
                    this.setState({
                        hasViewedAllObjectives: true
                    });
                }}
                updateJournalDataInline={(stage: string, payload: string, gameID: string) => {
                    // ignore this, we aren't letting them edit in this mode
                }}
            />
        </span>
    }

    calculate_is_changes_not_ready = () => {
        const {
            promptInput
        } = this.state;

        if (promptInput === undefined) return true;

        const keys = Object.keys(promptInput);

        if (keys.length === 0) return true;

        for (let i = 0; i < keys.length; i++) {
            const key = keys[i];
            if (key !== undefined && key !== "undefined") {
                const value = promptInput[key];

                if (value.length <= 0) {
                    return true;
                }
            }
        }

        return false;
    }

    renderJournalWarning = () => {
        const {
            hasViewedObjectives,
            hasViewedAllObjectives
        } = this.state;

        if (this.calculate_is_changes_not_ready() === false) {
            return '';
        }

        if (hasViewedObjectives === false) {
            return translateKey('vleader.shouldViewObjectives')
        }

        if (hasViewedAllObjectives === false) {
            return translateKey('vleader.shouldViewAllObjectives')
        }

        return translateKey('vleader.morePlan')
    }

    updateWrittenJournalFrompPrompt = (prompt, newValue) => {
        let copy = clone(this.state.writtenJouranl);

        let body = undefined;

        try {
            body = JSON.parse(copy);
        }
        catch(e) {
            body = {};
        }

        body[prompt] = newValue;

        this.setState({ writtenJouranl: JSON.stringify(body) })
    }

    getWrittenJournalFrompPrompt = (prompt) => {
        try {
            const body = JSON.parse(this.state.writtenJouranl);

            return body[prompt];
        }
        catch(e) {
            return this.state.writtenJouranl;
        }
    }

    renderDynamicJournal = (config) => {
        let sections: any[] = [];

        for (let i = 0; i < config.length; i++) {
            const {
                prompt
            } = config[i];

            const defaultValue = this.getWrittenJournalFrompPrompt(prompt);

            sections.push(
                <span style={{ width: '100%', flex: 1, alignSelf: 'center', justifyContent: 'top' }}>
                    <H4>{prompt}</H4>
                    <TextAreaV2 defaultValue={defaultValue} onChange={(event) => {
                        this.updateWrittenJournalFrompPrompt(prompt, event.target.value);
                    }} className={"journalTextArea"} rows={5} style={{ width: '100%', height: '90px' }}></TextAreaV2>
                </span>
            );
        }

        return <span style={{ flexShrink: 1, transition: 'all 2s' }}>
            <span style={{ position: 'relative', display: 'flex', flexDirection: 'row' }}>
                {sections}
            </span>
        </span>
    }

    renderJournal = () => {
        const dynamicConfiguration = getDynamicJournalConfiguration(this.props.user, this.props.menuConfig, true);

        if (dynamicConfiguration !== undefined) {
            return this.renderDynamicJournal(dynamicConfiguration);
        }

        let prompts = [];

        if (this.props.user.classicMode === 2) {
            if (this.state.promptData && this.state.promptData.classic) {
                for (let i = 0; i < this.state.promptData.classic.pre.length; i++) {
                    const __prompt = this.state.promptData.classic.pre[i];
                    const value = this.state.promptInput[__prompt];

                    prompts.push(
                        <div>
                            <H4 key={i}>{__prompt}</H4>
                            <TextAreaV2 value={value} onChange={(event) => {
                                this.setState({
                                    promptInput: Object.assign(this.state.promptInput, { [__prompt]: event.target.value })
                                });
                            }} className={"journalTextArea"} rows={5} style={{ width: '100%', height: '90px' }}></TextAreaV2>
                        </div>
                    );
                }
            }
        }
        else {
            if (this.state.promptData && this.state.promptData.lab) {
                for (let i = 0; i < this.state.promptData.lab.pre.length; i++) {
                    const __prompt = this.state.promptData.lab.pre[i];
                    const value = this.state.promptInput[__prompt];

                    prompts.push(
                        <div>
                            <H4 key={i}>{__prompt}</H4>
                            <TextAreaV2 value={value} onChange={(event) => {
                                this.setState({
                                    promptInput: Object.assign(this.state.promptInput, { [__prompt]: event.target.value })
                                });
                            }} className={"journalTextArea"} rows={5} style={{ width: '100%', height: '90px' }}></TextAreaV2>
                        </div>
                    );
                }
            }
        }

        return <span style={{ flexShrink: 1, transition: 'all 2s' }}>
            {prompts}
        </span>
    }

    renderGraphicButton = () => {
        return <span style={{ position: 'relative', top: this.state.viewGraphic ? buttonTopOffset : undefined, marginRight: '5px' }}>
            <Button onClick={() => { this.setState({ viewGraphic: true, viewSub2: false, viewSub1: false, viewSub3: false }) }} style={{ lineHeight: '50px', width: '200px', height: '50px' }} intent={Intent.PRIMARY}>{translateKey('vleader.reviewLesson')}</Button>
        </span>
    }

    renderGraphic1Button = () => {
        return <span style={{ position: 'relative', top: this.state.viewSub1 ? buttonTopOffset : undefined, marginRight: '5px' }}>
            <Button onClick={() => { this.setState({ viewGraphic: false, viewSub2: false, viewSub1: true, viewSub3: false }) }} style={{ lineHeight: '50px', width: '200px', height: '50px' }} intent={Intent.PRIMARY}>{translateKey('vleader.businessResults')}</Button>
        </span>
    }

    renderGraphic2Button = () => {
        return <span style={{ position: 'relative', top: this.state.viewSub2 ? buttonTopOffset : undefined, marginRight: '5px' }}>
            <Button onClick={() => { this.setState({ viewGraphic: false, viewSub2: true, viewSub1: false, viewSub3: false }) }} style={{ lineHeight: '50px', width: '200px', height: '50px' }} intent={Intent.PRIMARY}>{translateKey('vleader.commitmentScoring')}</Button>
        </span>
    }

    renderCoachingButton = () => {
        return <span style={{ position: 'relative', top: this.state.viewSub3 ? buttonTopOffset : undefined, marginRight: '5px' }}>
            <Button onClick={() => { this.setState({ viewGraphic: false, viewSub3: true, viewSub1: false, viewSub2: false }) }} style={{ lineHeight: '50px', width: '200px', height: '50px' }} intent={Intent.PRIMARY}>{translateKey('vleader.coaching')}</Button>
        </span>
    }

    calculate_journal_as_string = () => {
        let lines = [];

        const {
            promptInput
        } = this.state;

        const keys = promptInput ? Object.keys(promptInput) : [];

        for (let i = 0; i < keys.length; i++) {
            const key = keys[i];
            const value = promptInput[key];

            lines.push(`${value}`);
        }

        return lines.join('\n');
    }

    launchScenario = () => {
        this.props.recieveJournal(this.calculate_journal_as_string());
    }

    renderSaveButton = () => {
        const {
            hasViewedObjectives,
            hasViewedAllObjectives
        } = this.state;

        const warningMessage = this.renderJournalWarning();
        let shouldBeEnabled = this.calculate_is_changes_not_ready() === false;

        // Force the viewer to look at the objectives first
        if (hasViewedObjectives === false) {
            shouldBeEnabled = false;
        }

        // Force the viewer to look at all the objective categories as well
        if (hasViewedAllObjectives === false) {
            shouldBeEnabled = false;
        }

        const saveButton = <Button disabled={!shouldBeEnabled} style={{ lineHeight: '50px', width: '150px', height: '50px' }} onClick={() => {
            this.setState({
                showPlayButton: true
            });
        }} intent={Intent.SUCCESS}>{translateKey('vleader.savePlan')}</Button>

        if (warningMessage === undefined) {
            return saveButton;
        }

        return <Tooltip content={warningMessage}>
            {saveButton}
        </Tooltip>
    }

    renderAudioComponent = () => {
        return <CoachingAudio
            audioSource={this.props.coachingAudio}
            donePlaying={() => {
                this.setState({
                    hasAudioFinishedOnce: true
                });
            }}
        />
    }

    renderDisplayRegion = () => {
        return this.renderGraphic();
    }

    renderGoHomeButton = () => {
        return <div style={{ paddingRight: '5px', paddingLeft: '10px' }}>
            <Alert
                cancelButtonText="Cancel"
                confirmButtonText="Yes"

                onCancel={() => {
                    this.setState({
                        promptToGoHome: false
                    });
                }}

                onConfirm={() => {
                    this.props.goBackHome();
                }}

                intent={Intent.WARNING}
                isOpen={this.state.promptToGoHome}>
                <p>
                    Are you sure you want to go back to the main menu?
                </p>
            </Alert>

            <Button onClick={() => {
                this.setState({
                    isJournalVisible: true
                });
            }} style={{ lineHeight: '50px', width: '100px', height: '50px' }} intent={Intent.NONE}>Edit Plan</Button>

            <Button onClick={() => {
                this.setState({
                    promptToGoHome: true
                });
            }} style={{ lineHeight: '50px', width: '100px', height: '50px' }} intent={Intent.NONE}>Go Back</Button>
        </div>
    }

    renderControlRegion = () => {
        const {
            forLP,
            cachedSimulatedData
        } = this.props;

        const {
            isJournalVisible
        } = this.state;

        const hideLPElements = forLP === true;
        const hideCoachingElements = cachedSimulatedData === undefined;

        const mainControlButtons = [
            this.renderGraphicButton(),
            hideCoachingElements ? undefined : undefined,
            hideLPElements ? undefined : this.renderGraphic1Button(),
            hideLPElements ? undefined : this.renderGraphic2Button(),
            this.renderGoHomeButton(),
            this.renderSaveButton(),
        ]

        return <span style={{ width: '100%' }}>
            <span style={{ display: 'flex', flexDirection: 'row', justifyContent: 'right', float: 'right' }}>
                {isJournalVisible ? undefined : mainControlButtons}
            </span>
        </span>
    }

    renderFinalPlayButton = () => {
        return <div className="journalParent" style={{  width: '100%' }}>
            <span style={{ display: 'flex', flexDirection: 'column', height: '100%', flexWrap: 'wrap' }}>
                <span style={{ flexGrow: 1, flexBasis: 0 }}>
                    <span style={{ flexGrow: 1, flexBasis: 0 }}><LoadableSVG imgURL={this.props.journalGrphicPost} /></span>
                    <Button className="floatingPlayButton" onClick={() => { this.launchScenario() }} large intent={Intent.SUCCESS}>{translateKey('vleader.play')}</Button>
                </span>
            </span>
        </div>
    }

    render() {
        const {
            loadingObjectiveData,
            showPlayButton
        } = this.state;

        if (loadingObjectiveData) return <span style={{ display: 'block', width: '100%', margin: 'auto', marginTop: '40px' }}>
            <Spinner />
        </span>

        const journalDrawer = <Drawer
            onClose={() => {
                this.setState({
                    isJournalVisible: false
                })
            }}
            isOpen={this.state.isJournalVisible}
            position={Position.BOTTOM}
            canOutsideClickClose={true}
            canEscapeKeyClose={true}
            usePortal={false}
            autoFocus={true}
            enforceFocus={true}
            title="vLeader Journal"
        >
            <div className={Classes.DRAWER_BODY}>
                <div className={Classes.DIALOG_BODY}>
                    {this.renderJournal()}
                </div>
            </div>
            <div className={Classes.DRAWER_FOOTER}>
                <p style={{float: 'left'}}>Your instructor can use this to help and guide you.</p>
                <Button intent={Intent.PRIMARY} style={{float: 'right'}} onClick={() => {
                    this.setState({
                        isJournalVisible: false
                    })
                }}>Done</Button>
                <div className="clearfix" />
            </div>
        </Drawer>

        // TODO: Test this move of the "final play button" that in reality, is the main pre-game graphic
        return <div className="journalParent" style={{ width: '100%' }}>
            {journalDrawer}
            {this.renderAudioComponent()}
            <span style={{ display: 'flex', flexDirection: 'column', height: '100%', flexWrap: 'wrap' }}>
                {showPlayButton ? this.renderFinalPlayButton() : this.renderControlRegion()}
                {showPlayButton ? undefined : this.renderDisplayRegion()}
            </span>
        </div>
    }
}
